import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { getPanelName } from '../../panels/utils';
import { TabPanelLayout } from './layout';
export function TabPanel(Panel, layout_props) {
    return memo(function TabPanel(props) {
        const { panel_key, content, hide_title } = props;
        const { can_hide } = layout_props || {};
        const name = useMemo(() => getPanelName(panel_key, content?.length ?? 0), [content?.length, panel_key]);
        return (_jsx(TabPanelLayout, { can_hide: can_hide, panel_key: panel_key, title: name, hide_title: hide_title, children: _jsx(Panel, { ...props }) }));
    });
}
